import { lazy } from 'react';
// @ts-ignore
export const HomeScreenAsync = lazy(() => import('./HomeScreen.tsx'));
